













































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentEmitirRelatorioTabelaPropria extends Vue {
  loadEmitirRelatorio: boolean = false

  get modalEmitirRelatorio() { return this.getFinanceiroStore.modal.emitirRelatorio }
  set modalEmitirRelatorio(value: boolean) { this.getFinanceiroStore.setModal({ name: 'emitirRelatorio', value }) }

  get loadingEmitirRelatorio() { return this.loadEmitirRelatorio }
  set loadingEmitirRelatorio(value: boolean) { this.loadEmitirRelatorio = value }


  async emitirRelatorio() {
    this.loadingEmitirRelatorio = true
    
    const tabelaPrecoId = this.getFinanceiroStore.itemTabelaPreco.identificador
    const response = await this.getFinanceiroStore.emitirRelatorioTabelaPropria(tabelaPrecoId)
    if (response.success) {
      const link = document.createElement('a')
      link.href = this.getFinanceiroStore.relatorioEmitido
      link.download = 'relatorio.xlsx'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      EventBus.$emit('setSnackbar', { show: true, text: 'Relatório emitido com sucesso!', icon: 'done', color: '#2E7D32' })
      this.modalEmitirRelatorio = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao emitir o relatório.', icon: 'warning', color: '#C62828' })
    }
    this.loadingEmitirRelatorio = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
